import type { RouteLocationNormalizedGeneric } from '#vue-router'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useTutorSlotLogStore } from '@stores/tutor-slot-log'

import { useTutorsListApi } from '@api/tutors/list.hook'

import { getFirstQueryValue } from '@helpers/route'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useTutorSlotLogStore()

  const tutorId = getFirstQueryValue(to.query?.tutor_id)
  const slotStart = getFirstQueryValue(to.query?.slot_start)

  if (!tutorId || !slotStart) {
    store.resetFilters()
    return
  }

  const tutorIdNum = Number(tutorId)
  const [date, time] = slotStart.replace(/\+/g, ' ').split(' ')

  if (Number.isNaN(tutorIdNum) || !date || !time) {
    store.resetFilters()
    return
  }

  store.setFilterTutorId(tutorIdNum)
  store.setFilterDate(date)
  store.setFilterSlotTime(time.slice(0, 5))
  store.setHasSearched(false)

  void useTutorsListApi({ preselected: [tutorIdNum], page: 1 }).then((data) => {
    if (!data) return
    const option = data.items.find(o => o.value === tutorIdNum)
    if (option) store.setSelectedTutorOption(option as AppSelectOption<number>)
  })
})
